import { onValue, ref } from "firebase/database";
import { create } from "zustand";
import { db, mapKeys } from "../lib/firebase";
import { useAuthStore } from "./auth.store";

interface globalsState {
  globals: any | null;
  loading: boolean;
}

export const useGlobalsStore = create<globalsState>(set => ({
  globals: null,
  loading: false
}));

useAuthStore.subscribe(authState => {
  if (!authState.user) return;
  const globalsRef = ref(db, `globalConfigs/`);
  onValue(globalsRef, snapshot => {
    useGlobalsStore.setState({ loading: true });
    const data = snapshot.val();
    if (data) {
      useGlobalsStore.setState({ globals: data, loading: false });
    }
  });

  const strategiesRef = ref(db, "strategies/");
  onValue(strategiesRef, snapshot => {
    const data = snapshot.val();
    if (data) {
      useGlobalsStore.setState(({ globals }) => ({
        globals: { ...globals, strategies: mapKeys(data) },
        loading: false
      }));
    }
  });

  const payOutStructureRef = ref(db, "payOutStructure/");
  onValue(payOutStructureRef, snapshot => {
    const data = snapshot.val();
    if (data) {
      useGlobalsStore.setState(({ globals }) => ({
        globals: { ...globals, payOutStructure: data },
        loading: false
      }));
    }
  });
});
